// signupAvailability.js

/** Flip to true when public sign-up should reopen. */
export const SIGNUPS_ENABLED = false;

export const SIGNUPS_PAUSED_MESSAGE =
  "We're in private beta — new sign-ups are paused for now.";
